import { Button, ConfigProvider } from "antd";


import React from 'react'
import { Colors } from "../../config";
import useColors from "../../hooks/useColors";
import { twMerge } from "tailwind-merge";

const ButtonLoader = ({ loader, style, className, text, btnHandler, isDisabled, icon, ...rest }) => {
    return (
        <ConfigProvider theme={{
            components: {
                Button: {
                    colorPrimaryBorderHover: 'white',
                    colorPrimaryHover: 'white',
                    colorPrimary: 'white',
                    colorPrimaryActive: 'white',
                    colorPrimaryTextHover: 'white',
                    defaultHoverBg: "",
                    defaultActiveBg: "",
                    colorText: Colors.White
                }
            }
        }}>
            <Button
                htmlType="submit"
                loading={loader && true}
                style={{ ...style }}
                className={twMerge(className, 'border-none')}
                onClick={btnHandler}
                disabled={isDisabled}
                icon={icon}
                {...rest}
            >{text}
            </Button>
        </ConfigProvider>
    )
}

export default ButtonLoader